import { CalendarRange, ClipboardList, LayoutGrid, Settings, ShoppingCart } from 'lucide-react';

/** Le schede della pagina di un evento, nell'ordine in cui si lavora. */
export type SchedaEvento = 'programma' | 'biglietti' | 'richieste' | 'assegnazioni' | 'impostazioni';

export const SCHEDE: { id: SchedaEvento; etichetta: string; icona: typeof Settings }[] = [
  { id: 'programma', etichetta: 'Programma', icona: CalendarRange },
  { id: 'biglietti', etichetta: 'Biglietti', icona: ShoppingCart },
  { id: 'richieste', etichetta: 'Richieste', icona: ClipboardList },
  { id: 'assegnazioni', etichetta: 'Assegnazioni', icona: LayoutGrid },
  { id: 'impostazioni', etichetta: 'Impostazioni', icona: Settings },
];

export const eScheda = (valore: string | null): valore is SchedaEvento => SCHEDE.some((s) => s.id === valore);
